<h1 class="heading">Tham khảo bảng giá linh kiện tại TTBH Ủy Quyền Samsung</h1>
<ol class="ordered-list" style="list-style-type: decimal; padding-top: 20px;">
    <li>Bảng giá bên dưới được khuyến nghị bởi Công Ty Điện Tử Samsung Vina đối với dịch vụ sửa chữa tại các TTBH Ủy Quyền Samsung trên toàn quốc.</li>
    <li class="list-item">Tiền công sửa chữa thay thế tham khảo đối với Màn hình (LCD) hoặc Bo mạch chính (PBA) là 200,000 VNĐ.</li>
    <li>Tổng chi phí sửa chữa sẽ bao gồm tiền linh kiện thay thế, tiền công, các chi phí khác và thuế theo quy định nếu có (Tổng chi phí có thể thay đổi giữa các Trung Tâm tùy theo từng địa phương). Bảng giá được tính bằng VNĐ và chưa bao gồm các loại thuế
        theo quy định.</li>
</ol>
<ul class="a-container">
    <li class="a-items" *ngFor="let tag of priceTableTag">
        <input #myname style="display: none;" type="text" value={{tag.key}}>
        <input type="radio" name="ac" id="{{tag.key}}" />
        <label for="{{tag.key}}"><strong>{{tag.name}}</strong></label>
        <div class="a-content">
            <ul class="a-container">
                <li class="a-items" *ngFor="let priceTag of priceNotice">
                    <div class="content">
                        <a [href]="priceTag.link | async" target="_blank">
                            <h4>{{priceTag.name}}</h4>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </li>
</ul>